import React, { MouseEvent as ReactMouseEvent, ReactNode } from "react";
import IconButton, { IconButtonOwnProps } from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { OverridableStringUnion } from "@mui/types";
import { ButtonPropsColorOverrides } from "@mui/material";
import { ButtonSize } from "@/types/types.ts";

export type ButtonWithIconProps<T = HTMLElement> = {
  style?: object;
  className?: string;
  sx?: object;
  color?: OverridableStringUnion<
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning"
    | "default"
    | "neutral",
    ButtonPropsColorOverrides
  >;
  tooltip?: string;
  size?: ButtonSize;
  id?: string;
  icon?: ReactNode;
  onClick?: (event: ReactMouseEvent<T>) => void;
  onMouseEnter?: (event: ReactMouseEvent<T>) => void;
  onClickCapture?: (event: ReactMouseEvent<T>) => void;
  onMouseOver?: (event: ReactMouseEvent<T>) => void;
  disabled?: boolean;
  isActive?: boolean | null;
  isSvgComponent?: boolean;
  edge?: IconButtonOwnProps["edge"];
  elevation?: number; // Accept elevation level
};

export const ButtonWithIcon = (props: ButtonWithIconProps) => {
  const renderIcon = () => props.icon;
  const renderButton = () => {
    return (
      <IconButton
        id={props.id}
        disabled={props.disabled}
        sx={{
          ...props.sx,
        }}
        className={props.className ?? ""}
        color={props.isActive ? "primary" : "default"}
        size={props.size}
        onClick={props.onClick}
        onClickCapture={props.onClickCapture}
        onMouseOver={props.onMouseOver}
      >
        {renderIcon()}
      </IconButton>
    );
  };

  if (props.tooltip && !props.disabled) {
    return <Tooltip arrow title={props.tooltip}>{renderButton()}</Tooltip>;
  }

  return renderButton();
}
